import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import api from "./api";
import { AppThunk } from "./app";
import API_URL from "../config/ApiUrl";

interface CommonState {
  status: [];
  privilegesList: [];
  rolesList: [];
  translation: {
    show: boolean,
    className: string,
  },
  translationLanguage?: any,
  showIntrestPopup: boolean
  showContactPopup: boolean,
  hasAccessCodePopup: boolean,
  hasAccessCodeStatus: boolean,
  hasProfileUpdated:boolean
}

const initialState = {
  status: [],
  privilegesList: [],
  rolesList: [],
  translation: {
    show: false,
    className: '',
  },
  translationLanguage: 'en',
  showIntrestPopup: false,
  showContactPopup: false,
  hasAccessCodePopup: false,
  hasAccessCodeStatus: false,
  hasProfileUpdated: false,
} as CommonState;

const CommonSlice = createSlice({
  name: "COMMON",
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<any>) => {
      state.status = action.payload;
    },
    setPrivilegesList: (state, action: PayloadAction<any>) => {
      state.privilegesList = action.payload;
    },
    setRolesList: (state, action: PayloadAction<any>) => {
      state.rolesList = action.payload;
    },
    setTranlsation: (state, action: PayloadAction<any>) => {
      state.translation = action.payload;
    },
    setTranslationLanguage: (state, action: PayloadAction<any>) => {
      state.translationLanguage = action.payload;
    },
    setShowIntrestPopup: (state, action: PayloadAction<any>) => {
      state.showIntrestPopup = action.payload;
    },
    setShowContactPopup: (state, action: PayloadAction<any>) => {
      state.showContactPopup = action.payload;
    },
    setHasAccessCodePopup: (state, action: PayloadAction<any>) => {
      state.hasAccessCodePopup = action.payload;
    },
    setHasAccessCodeStatus: (state, action: PayloadAction<any>) => {
      state.hasAccessCodeStatus = action.payload;
    },
    setHasProfileUpdated: (state, action: PayloadAction<any>) => {
      state.hasProfileUpdated = action.payload;
    },
  },
});

export const { setStatus, setPrivilegesList, setRolesList, setTranlsation,setTranslationLanguage, setShowIntrestPopup, setShowContactPopup, setHasAccessCodePopup, setHasAccessCodeStatus,setHasProfileUpdated } =
  CommonSlice.actions;

export const fetchPrivilegesList = (): AppThunk<any> => async (dispatch) => {
  try {
    const response = await api.get(API_URL.COMMON.PRIVILEGES);
    dispatch(setPrivilegesList(response.data));
    return Promise.resolve(response.data);
  } catch (error: any) {
    dispatch(setPrivilegesList([]));
    return Promise.reject(error.data);
  }
};
export const fetchRolesList =
  (payload?: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.get(API_URL.COMMON.ROLES_LIST(payload));
        dispatch(setRolesList(response.data?.data));
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(setRolesList([]));
        return Promise.reject(error.data);
      }
    };

const CommonSliceReducer = CommonSlice.reducer;
export default CommonSliceReducer;
